<template>
  <article class="px-0 py-0 my-0">
    <section class="px-7 px-xl-9 py-14 m-0">
      <div style="max-width:704px" class="mx-auto">
        <h2 class="by-heading-2 text-by-blue-100 mb-5">Datenschutzerklärung</h2>
        <p class="mb-0 by-copy-large-regular text-by-neutral-100">
          Diese Datenschutzerklärung bezieht sich auf die Verarbeitung personenbezogener Daten im
          Rahmen dieses Internetauftritts (open.bydata.de und oc.bydata.de), einschließlich der dort
          unmittelbar angebotenen Dienste. Sie bezieht sich nicht auf die Verarbeitung
          personenbezogener Daten auf Seiten Dritter, auf die wir über Links verweisen.
          <br><br>
          Hinsichtlich Internetseiten mit dem Domainnamen „.bydata.de" (z. B. musterstadt.bydata.de)
          bezieht sich die Datenschutzerklärung lediglich auf die Bereitstellung und das Hosting der
          jeweiligen Webseite sowie die Beschreibung der bereitgestellten Daten (Metadaten). Die zum
          Download oder über eine externe Schnittstelle bereitgestellten Daten selbst werden nicht
          von uns gehostet, sondern es wird lediglich hierauf verlinkt. Verantwortlich ist der
          jeweilige Datenbereitsteller (z. B. „Musterstadt").
          <br><br>
          Unter Datenbereitsteller verstehen wir Anbieter aus dem öffentlichen und privaten Sektor,
          die über das Portal „open.bydata.de" oder eine Open Data Präsenz unter der Second Level
          Domain „.bydata.de" offene Daten und Dokumente zugänglich machen.
          <br><br>
          Für nähere Informationen zur Verarbeitung Ihrer personenbezogenen Daten können Sie uns
          unter den genannten Kontaktdaten unter "Allgemeine Hinweise" erreichen.
        </p>
      </div>
    </section>
    <section class="m-0 py-11 px-7 px-xl-9 bg-by-neutral-10">
      <div style="max-width:704px" class="mx-auto">
        <h3 class="by-heading-3 text-by-blue-100 mb-9">Allgemeine Hinweise</h3>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wer ist verantwortlich für die Datenverarbeitung?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          byte – Bayerische Agentur für Digitales GmbH<br>
          Orleansstraße 24<br>
          81669 München<br>
          <a href="mailto:datenschutz@byte.bayern">datenschutz@byte.bayern</a>
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wer ist der Datenschutzbeauftragte?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Andreas Hensel<br>
          INFODAS GmbH<br>
          Rhonestraße 1<br>
          50765 Köln<br>
          <a href="mailto:A.Hensel@infodas.de">A.Hensel@infodas.de</a>
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche Rechte habe ich als betroffene Person?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Soweit wir von Ihnen personenbezogene Daten verarbeiten, stehen Ihnen als Betroffener
          nachfolgende Rechte zu:
          <ul class="mb-0 pl-4">
            <li>das Recht auf Auskunft (Art. 15 DSGVO),</li>
            <li>das Recht auf Berichtigung nach (Art. 16 DSGVO),</li>
            <li>das Recht auf Löschung nach (Art. 17 DSGVO),</li>
            <li>das Recht auf Einschränkung der Verarbeitung nach (Art. 18 DSGVO),</li>
            <li>das Recht auf Unterrichtung über die Maßnahmen nach Artikeln 16 bis 18 DSGVO
              (Art. 19 DSGVO), sowie</li>
            <li>das Recht auf Datenübertragbarkeit (Art. 20 DSGVO).</li>
          </ul>
          <br>
          Unter den Voraussetzungen des Art. 21 DSGVO können Sie jederzeit der weiteren Speicherung
          und Verwendung Ihrer Daten durch eine Mitteilung an
          <a href="mailto:datenschutz@byte.bayern">datenschutz@byte.bayern</a> widersprechen. Dies
          gilt für die Verarbeitung personenbezogener Daten aufgrund von Art. 6 Abs. 1 S. 1 lit. e
          DSGVO i.V.m Art. 14 BayDiG.
          <br><br>
          Soweit eine Verarbeitung auf einer von Ihnen erteilten Einwilligung beruht, können Sie die
          Einwilligung jederzeit für die Zukunft widerrufen, Art. 7 Abs. 3 DSGVO. Die Rechtmäßigkeit
          der aufgrund der Einwilligung bis zum Widerruf erfolgten Datenverarbeitung wird hierdurch
          nicht berührt.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Kann ich mich bei der Aufsichtsbehörde beschweren?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Sie haben das Recht, sich beim Bayerischen Landesbeauftragten für den Datenschutz (BayLfD)
          zu beschweren. Diesen können Sie unter folgenden Kontaktdaten erreichen:
          <br><br>
          Postanschrift: Postfach 22 12 19, 80502 München<br>
          Adresse: Wagmüllerstraße 18, 80538 München<br>
          Telefon: 089 / 212672-0<br>
          Telefax: 089 / 212672-50<br>
          E-Mail: <a href="mailto:poststelle@datenschutz-bayern.de">poststelle@datenschutz-bayern.de</a><br>
          Internet: <a href="https://www.datenschutz-bayern.de/">www.datenschutz-bayern.de</a>
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          An welche besonderen Stellen werden meine personenbezogenen möglicherweise übermittelt?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Gegebenenfalls werden Ihre Daten an die zuständigen Aufsichts- und
          Rechnungsprüfungsbehörden zur Wahrnehmung der jeweiligen Kontrollrechte übermittelt.
          <br><br>
          Bei elektronischer Übermittlung von Daten können diese Daten zur Abwehr von Gefahren für
          die Sicherheit in der Informationstechnik an das Bayerische Landesamt für Sicherheit in der
          Informationstechnik weitergeleitet werden und dort auf Grundlage von Art. 44 ff. des
          Bayerischen E-Government-Gesetzes verarbeitet werden.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Bereitstellung der Webseiten und Hosting
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Dieser Abschnitt betrifft die Verarbeitung Ihrer personenbezogenen Daten zur
          Bereitstellung unserer Webseiten.
          <br><br>
          Unsere Webseiten werden von unserem Dienstleister<br>
          DKSR GmbH<br>
          Linienstraße 86<br>
          10119 Berlin<br>
          gehostet.
          <br><br>
          Unser Dienstleister nutzt die Google Cloud Plattform von<br>
          Google Ireland Limited,<br>
          Gordon House, Barrow Street<br>
          Dublin 4<br>
          Irland.
          <br><br>
          Der geografische Standort des genutzten Servers ist Deutschland (Frankfurt am Main).
          <br><br>
          <a href="https://policies.google.com/privacy">Hier erhalten Sie weitere Informationen
          über die Verarbeitung Ihrer Daten durch Google.</a>
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche personenbezogenen Daten werden wie verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wenn Sie unsere Webseiten aufrufen, übermitteln Sie über Ihren Internetbrowser Daten an
          unseren Webserver. Die folgenden Daten werden während einer laufenden Verbindung zur
          Kommunikation zwischen Ihrem Internetbrowser und unserem Webserver aufgezeichnet:
          <ul class="mb-0 pl-4">
            <li>Datum und Uhrzeit der Anforderung</li>
            <li>Name der angeforderten Datei</li>
            <li>Seite, von der aus eine Datei angefordert wurde</li>
            <li>Zugriffsstatus (beispielsweise Datei übertragen, Datei nicht gefunden)</li>
            <li>verwendete Webbrowser und verwendetes Betriebssystem</li>
            <li>vollständige IP-Adresse des anfordernden Rechners</li>
            <li>übertragene Datenmenge</li>
          </ul>
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Zu welchem Zweck werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wir verarbeiten Ihre Daten für die Darstellung und Optimierung unserer Webseite, sowie für
          den Betrieb unserer Plattform open.bydata.
          <br><br>
          Aus Gründen der technischen Sicherheit, insbesondere zur Abwehr von Angriffsversuchen auf
          unseren Webserver, werden diese Daten von uns gespeichert. Die IP-Adresse des anfordernden
          Rechners wird übertragen, aber durch uns sofort ersetzt, so dass es nicht mehr möglich
          ist, einen Bezug auf einzelne Nutzer herzustellen.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Rechtsgrundlage für die Übertragung und vorübergehende Speicherung ist Art. 6 Abs. 1 lit. e
          DSGVO i.V.m. Art. 14 BayDiG.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wie lange werden diese Daten gespeichert?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Die IP-Adresse als einziges Datum, das Ihre Identifikation ermöglicht, wird unmittelbar
          nach der Übertragung anonymisiert.
        </p>
      </div>
    </section>
    <section class="px-7 px-xl-9 py-14 m-0">
      <div style="max-width:704px" class="mx-auto">
        <h3 class="by-heading-3 text-by-blue-100 mb-9">Kontakt per E-Mail</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Dieser Abschnitt betrifft die Verarbeitung Ihrer personenbezogenen Daten bei der
          Kontaktaufnahme über die von uns bereitgestellten E-Mail-Adressen an die verantwortliche
          Stelle.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche personenbezogenen Daten werden wie verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Kontaktieren Sie uns per E-Mail, werden die hiermit übermittelten Daten bei uns
          gespeichert.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Zu welchem Zweck werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Die übermittelten Daten werden ausschließlich für die Kommunikation mit Ihnen verwendet.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wir verarbeiten Ihre personenbezogenen Daten, die Sie per E-Mail an uns übermitteln auf
          Grundlage des Art. 6 Abs. 1 lit. e DSGVO iVm Art. 14 BayDiG. Die Verarbeitung ist zur
          <strong>Wahrnehmung einer Aufgabe im öffentlichen Interesse</strong> erforderlich,
          insbesondere zur Bearbeitung und Beantwortung Ihrer an uns gerichteten Anfragen.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wie lange werden diese Daten gespeichert?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wir verarbeiten die von Ihnen zur Kontaktaufnahme erhaltenen personenbezogenen Daten nur
          so lange, bis wir Ihre Anfrage abschließend beantwortet haben. Darüber hinaus speichern
          wir Ihre personenbezogenen Daten nur falls und so lange sie zur Geltendmachung von oder
          Verteidigung gegen rechtliche Ansprüche notwendig sind oder so lange gesetzliche Pflichten
          zur Speicherung bestehen.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-9">Kontakt per Kontaktformular (Typeform)</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Dieser Abschnitt betrifft die Verarbeitung Ihrer personenbezogenen Daten bei der
          Kontaktaufnahme über unser Kontaktformular zu einem der folgenden Themen:
          <ul class="mb-0 pl-4">
            <li><a href="https://form.typeform.com/to/ewn4iItc">Allgemeine Kontaktaufnahme</a></li>
            <li><a href="https://form.typeform.com/to/c7ogS262">Anfrage Beratungstermin</a></li>
            <li><a href="https://form.typeform.com/to/RW04HY9p">Datenanfrage</a></li>
            <li><a href="https://form.typeform.com/to/e0hV2J6W">User Feedback</a></li>
            <li><a href="https://form.typeform.com/to/e8emtcUr">Anmeldung zum Newsletter</a></li>
            <li><a href="https://form.typeform.com/to/flNZURrD">Abmeldung vom Newsletter</a></li>
            <li><a href="https://form.typeform.com/to/uEkXb2Hx">Einreichung eines Use Case</a>
              (d.h. Anwendungsbeispiel für die Nutzung von Open Data)</li>
            <li>Anmeldung und Feedback zu Events (z. B. Round Table, Love Data Week)</li>
            <li>Inhaltsabfrage für Open Data Präsenzen unter der Second Level Domain
              „.bydata.de"</li>
            <li>Kontaktformular für neue Datenbereitsteller / Einverständniserklärung</li>
          </ul>
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche personenbezogenen Daten werden wie verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          In unseren Kontaktformularen fragen wir u.a. personenbezogene Daten (Vor- und Nachname,
          berufliche Position, Telefonnummer, E-Mail-Adresse) ab. Darüber hinaus können Sie eine
          Nachricht eingeben.
          <br><br>
          Wir verwenden für unser Kontaktformular den Dienst von TYPEFORM SL, C/ Can Rabia 3-5,
          4th floor, 08017, Barcelona (Spanien).
          <br><br>
          Typeform ist als Auftragsverarbeiter für uns tätig.
          <br><br>
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Bei der Nutzung unserer Typeform-Formulare können Cookies gesetzt werden, die für die
          technische Bereitstellung des Formulars erforderlich sind, vgl. hierzu das anschließende
          Kapitel „Verwendung von Cookies". Zu welchem Zweck werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Die übermittelten Daten werden ausschließlich für die Bearbeitung der oben genannten
          Themen verwendet.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Mit der Verwendung unseres Kontaktformulars willigen Sie in die Verarbeitung der von Ihnen
          übermittelten Daten ein. Diese Einwilligung ist die Rechtsgrundlage für die Verarbeitung
          dieser Daten gemäß Art. 6 Abs. 1 lit. e DSGVO iVm Art. 14 BayDiG.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wie lange werden diese Daten gespeichert?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wir verarbeiten die von Ihnen zur Kontaktaufnahme erhaltenen personenbezogenen Daten nur
          so lange, bis wir Ihr Anliegen abschließend beantwortet haben. Darüber hinaus speichern
          wir Ihre personenbezogenen Daten nur falls und so lange sie zur Geltendmachung von oder
          Verteidigung gegen rechtliche Ansprüche notwendig sind oder so lange gesetzliche Pflichten
          zur Speicherung bestehen.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-9">Webstatistik (Matomo)</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Dieser Abschnitt betrifft das von uns genutzte Statistiktool Matomo.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche personenbezogenen Daten werden wie verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wir betreiben Matomo in einer Version, die nach Zustimmung Cookies einsetzt. Für die
          Analyse der Website-Nutzung werden Ihre IP-Adresse und Informationen wie Zeitstempel,
          besuchte Webseiten und Ihre Spracheinstellungen erfasst. Wir verwenden Matomo mit der
          Erweiterung „AnonymizeIP". Dadurch werden IP-Adressen gekürzt weiterverarbeitet und eine
          direkte Personenbeziehbarkeit ausgeschlossen. Die anonymen Statistikdaten werden getrennt
          von Ihren eventuell angegebenen personenbezogenen Daten gespeichert und lassen keine
          Rückschlüsse auf eine bestimmte Person zu.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Zu welchem Zweck werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Die Daten werden für die Darstellung und zur Optimierung unserer Webseiten verarbeitet.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Rechtsgrundlage für die Erfassung und Anonymisierung Ihrer personenbezogenen Daten ist
          Art. 6 Abs. 1 lit. e DSGVO iVm Art. 14 BayDiG. Die Verarbeitung ist zur
          <strong>Wahrnehmung einer Aufgabe im öffentlichen Interesse</strong> erforderlich, um die
          Funktionalität der Webseite und der dort angebotenen Dienste technisch zu
          gewährleisten.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wie lange werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Ihre Daten werden nur bis zur unverzüglichen Anonymisierung als personenbezogene Daten
          verarbeitet.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-9">Verwendung von Cookies</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Dieser Abschnitt betrifft die Verarbeitung Ihrer personenbezogenen Daten bei der
          Verwendung von Cookies. Unsere Webseite verwendet Cookies. Das sind kleine Textdateien,
          die von Webseiten verwendet werden, um die Benutzererfahrung effizienter zu gestalten. Sie
          werden auf Ihrem Computer oder mobilen Gerät gespeichert und enthalten Informationen wie
          Anmeldeinformationen, Spracheinstellungen oder Surfverhalten.
          <br><br>
          Für die Nutzung technisch notwendiger Cookies ist Ihre Einwilligung nicht erforderlich,
          § 25 Abs. 2 TDDDG.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche Cookies verwenden wir auf unserer Webseite?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Welche Cookies auf unserer Webseite verwendet werden, wie lange die Cookies gespeichert
          werden und die Einstellungen hierfür können Sie mit Klick auf das Symbol unten links auf
          unserer Webseite einsehen.
          <br><br>
          Das Symbol sieht so aus
          <img src="/static/cookiebot-icon.png" alt="Cookie Einstellungen Symbol" style="display: inline-block; vertical-align: middle; width: 24px; height: 24px;" />
          und öffnet das Fenster „Cookie Einstellungen" Bitte klicken Sie
          dort für weitere Details auf „Einwilligung ändern".
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche personenbezogenen Daten werden wie verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Werden über ein Cookie personenbezogene Daten verarbeitet, wird dies detailliert in den
          Cookie Einstellung angegeben.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Zu welchem Zweck werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren und die Zugriffe auf
          unsere Website zu analysieren.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Rechtsgrundlage für die Verarbeitung Ihrer personenbezogenen Daten mittels technisch
          notwendiger Cookies ist § 25 Abs. 1 TDDDG. Die Verarbeitung ist zur
          <strong>Wahrnehmung einer Aufgabe im öffentlichen Interesse</strong> erforderlich, um die
          Funktionalität der Webseite und der dort angebotenen Dienste technisch zu
          gewährleisten. Sofern Sie den technisch nicht erforderlichen Cookies über das
          Auswahlmenü („Cookiebanner") zustimmen, ist die Rechtsgrundlage § 25 Abs. 1 TDDDG.
          Unabhängig davon können von eingebetteten Diensten von Drittanbietern wie Typeform
          Cookies verwendet werden. Rechtsgrundlage für optional gesetzte Cookies von Typeform ist
          § 25 Abs. 1 TDDDG. Weitere Informationen hierzu finden Sie in der
          <a href="https://admin.typeform.com/to/dwk6gt/">Cookie-Richtlinie von Typeform</a>.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wie lange werden diese Daten gespeichert?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Cookies werden auf Ihrem Endgerät gespeichert. Sie haben jederzeit die Möglichkeit, über
          Ihre Browsereinstellungen die Übertragung von Cookies zu deaktivieren oder einzuschränken
          und die Cookies zu löschen.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-9">open.bydata.de Plattform</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Dieser Abschnitt betrifft unsere offene Datenplattform open.bydata.de. Unsere Plattform
          macht es lediglich möglich, die von einem Datenbereitsteller bei sich gespeicherten Daten
          von dessen Server abzurufen. Diese Daten des Datenbereitstellers werden nicht über unsere
          Datenverarbeitungssysteme geleitet und somit nicht von uns verarbeitet. Insoweit sind
          Widersprüche und sonstige Anfragen bezüglich der Verarbeitung personenbezogener Daten an
          den jeweiligen Datenbereitsteller zu richten.
          <br><br>
          Auf unserer Plattform werden jedoch folgende Metadaten gespeichert und auf unserer
          Webseite dargestellt oder über unsere API zugänglich gemacht:
          <ul class="mb-0 pl-4">
            <li>Name des Datenbereitstellers</li>
            <li>Datum der Einstellung des Datensatzes in die Plattform</li>
            <li>Datum der letzten Aktualisierung des Datensatzes</li>
            <li>Sprache des Datensatzes</li>
            <li>Informationen über den jeweiligen Datensatz</li>
            <li>Lizenz- bzw. Urheberinformationen</li>
          </ul>
          <br>
          <strong>Datenbereitsteller</strong> sind Akteure oder Organisationen, die Daten zur
          Verfügung stellen. Dazu zählen insbesondere Einrichtungen der öffentlichen Verwaltung,
          aber auch Akteure aus Wissenschaft, Verbänden, Vereinen, der Privatwirtschaft sowie
          gegebenenfalls Privatpersonen.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche personenbezogenen Daten werden wie verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          In den Informationen über den jeweiligen Datensatz können personenbezogene Daten enthalten
          sein. Dies sind insbesondere Kontaktdaten zu den Mitarbeitenden der
          Datenbereitsteller, die Datensätze über unserer Plattform zugänglich machen. Wir fordern
          die Datenbereitsteller auf, keine personenbezogenen Daten in diesen Informationen über
          den jeweiligen Datensatz aufzuführen.
          <br><br>
          In den Lizenz- bzw. Urheberinformationen können personenbezogene Daten der Urheber des
          jeweiligen Datensatzes enthalten sein. Viele Open Source Lizenzen (z. B.
          <a href="https://creativecommons.org/licenses/by/4.0/deed.de">CC BY 4.0</a>) verpflichten
          zur Nennung der Urheber.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Zu welchem Zweck werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Durch das Veröffentlichen der Metadaten wird die zielgruppenorientierte und
          nutzerfreundliche Bereitstellung offener Verwaltungsdaten auf unserer Plattform
          open.bydata.de ermöglicht.
          <br><br>
          Durch die Namensnennung der Urheber bestimmter Datensätze wird den Nutzern ermöglicht, die
          Lizenzbedingungen einzuhalten.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO hinsichtlich der
          Nennung von Urhebern aufgrund von Lizenzbestimmungen und im Übrigen Art. 6 Abs. 1 lit. f
          DSGVO. Unser berechtigtes Interesse ist die zielgruppenorientierte und nutzerfreundliche
          Umsetzung der open.bydata.de Plattform.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wie lange werden diese Daten gespeichert?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Die Daten werden nur so lange gespeichert, wie sie für den oben genannten Zweck benötigt
          werden. Da die Datensätze regelmäßig unbefristet von den Datenbereitstellern zur
          Verfügung gestellt werden, werden auch die Metadaten zunächst unbefristet verarbeitet und
          nur gelöscht, wenn der entsprechende Datensatz nicht mehr bereitgestellt wird.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Müssen wir Betroffene über die Verarbeitung Ihrer Daten direkt informieren?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Nein. Sollten personenbezogene Daten in den Metadaten enthalten sein, können wir die
          Informationen nach Art. 14 Abs. 1 bis 3 DSGVO nicht direkt an den jeweiligen Betroffenen
          übermitteln. Dies umzusetzen würde erfordern, dass jede einzelne Information in den
          Metadaten des Datenbereitstellers von uns geprüft wird und beim Datenbereitsteller
          weitere personenbezogene Daten der betroffenen Person (Kontaktdaten) erhoben werden. Ein
          solcher Aufwand wäre aufgrund der Menge an Datensätzen und der begrenzten Zahl an
          Beschäftigten, die unsere Plattform betreuen unverhältnismäßig i. S. d. Art. 14 Abs. 5
          lit. b DSGVO. Dies gilt insbesondere mit Blick auf die Verarbeitung der Daten im
          öffentlichen Interesse. Um etwaigen betroffenen Personen den Zugang zu Informationen nach
          Art. 14 Abs. 1 und 2 DSGVO zu ermöglichen, haben wir diese in dieser
          Datenschutzerklärung aufgeführt.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-9">Customer Relationship Management</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Dieser Abschnitt betrifft unser Customer Relationship Management (CRM). Wir betreiben ein
          CRM, in dem wir Kontaktdaten von Beschäftigten von Datenbereitstellern, Partnern und
          Datennutzenden ("Community") pflegen.
          <br><br>
          Unter Partnern verstehen wir Dienstleister und Kooperationspartner, die das Thema Open
          Data in der öffentlichen Verwaltung mit uns gemeinsam stärken und fördern wollen. Hierbei
          handelt es sich z. B. um Unternehmen, die im Bereich Digitalisierung und Open Data tätig
          sind und Kommunen beraten.
          <br><br>
          Unter Community verstehen wir Unternehmen, Einrichtungen der Zivilgesellschaft (z. B.
          Vereine, gemeinnützige Organisationen) oder Einzelpersonen, die offene Daten nutzen und
          Use Cases zur Verfügung stellen können.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Welche personenbezogenen Daten werden wie verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Im Onboardingprozess für die Datenbereitstellung fragen wir über unser Kontaktformular
          für neue Datenbereitsteller (siehe Abschnitt: Kontakt per Kontaktformular (Typeform))
          Kontaktdaten (Vor- und Nachname, E-Mail-Adresse, Telefonnummer) der für die
          Datenbereitstellung verantwortlichen Person, sowie weitere Informationen zur Institution,
          die Daten bereitstellt, ab.
          <br><br>
          Kontaktdaten zu Datenbereitstellern, Partnern und Personen aus der Community erhalten wir
          auf von uns veranstalteten oder externen Events (z.B. Workshops, Roadshows), durch aktive
          Kontaktaufnahme (z. B. durch ein Kontaktformular) durch die Personen oder durch aktive
          Ansprache der Personen durch uns.
          <br><br>
          Folgende personenbezogene Daten werden erhoben:
          <ul class="mb-0 pl-4">
            <li>Vor- und Nachname</li>
            <li>Gegebenenfalls Rolle / Position</li>
            <li>E-Mail-Adresse</li>
            <li>Telefonnummer</li>
          </ul>
          <br>
          Diese Daten werden in unserer Customer-Relationship-Management-Anwendung im Programm
          „Notion" gespeichert und mit weiteren Informationen angereichert, die im Laufe der Zeit
          durch die gemeinsame Kommunikation anfallen.
          <br><br>
          Die Anwendung wird von der Notion Labs, Inc., 2300 Harrison Street, San Francisco, CA
          94110, United States („Notion Labs") zur Verfügung gestellt. Die erhobenen Daten werden
          auf einem von Notion bereit gestellten Online-Speicher („Cloud") gespeichert.
          <br><br>
          Nähere Informationen zur Datenverarbeitung durch Notion Labs sind
          <a href="https://www.notion.com/de/help/category/security-and-privacy">hier</a> abrufbar.
          <br><br>
          Notion Labs ist als Auftragsverarbeiter für uns tätig.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Zu welchem Zweck werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Die übermittelten Daten werden vertraulich behandelt und ausschließlich zum Zweck der
          Kommunikation mit Datenbereitstellern, Partnern und der Community zur Unterstützung bei
          der Bereitstellung von Daten, der Nutzung von Daten, Vernetzung und der Verbesserung
          unseres Angebots verarbeitet. Gegebenenfalls werden Ihre Kontaktdaten für den Versand von
          Newslettern verwendet, sofern Sie oder der Datenbereitsteller hierin eingewilligt haben.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Im Rahmen der Verwendung unseres Kontaktformulars für Datenbereitsteller willigen Sie in
          die Verarbeitung der von Ihnen übermittelten Daten ein. Diese Einwilligung ist die
          Rechtsgrundlage für die Verarbeitung dieser Daten gemäß Art. 6 Abs. 1 lit. a DSGVO.
          <br><br>
          Darüber hinaus ist Rechtsgrundlage für die Verarbeitung dieser Daten Art. 6 Abs. 1 lit. e
          DSGVO iVm Art. 14 BayDiG. Die Verarbeitung ist zur
          <strong>Wahrnehmung einer Aufgabe im öffentlichen Interesse</strong> erforderlich, um
          eine sichere Rechteverwaltung und den gesteuerten Zugang zu den Plattformfunktionen für
          berechtigte Organisationen zu ermöglichen.
        </p>
        <h4 class="by-heading-4 text-by-blue-100 mb-4">
          Wie lange werden diese Daten gespeichert?
        </h4>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Personenbezogene Daten von Mitarbeitenden der Datenbereitsteller speichern wir, so lange
          die Datenbereitstellung erfolgt und uns kein anderer Ansprechpartner genannt wird.
          <br><br>
          Bei Eingang einer Löschanfrage (per E-Mail im Postfach
          <a href="mailto:oc@bydata.de">oc@bydata.de</a>) sind alle Kontaktdaten der entsprechenden
          Person unverzüglich zu löschen, spätestens jedoch 30 Kalendertage ab Zugang der
          Löschanfrage.
          <br><br>
          Bei Benennung eines neuen Ansprechpartners werden die personenbezogenen Daten des
          ausgeschiedenen Ansprechpartners innerhalb von 30 Kalendertagen ab Zugang der Benennung
          des neuen Ansprechpartners gelöscht.
          <br><br>
          Personenbezogene Daten von Partnern oder aus der Community werden auf Aufforderung oder
          spätestens 24 Monate nach dem letzten Kontakt gelöscht. Darüber hinaus speichern wir Ihre
          personenbezogenen Daten nur falls und so lange sie zur Geltendmachung von oder
          Verteidigung gegen rechtliche Ansprüche notwendig sind oder so lange gesetzliche Pflichten
          zur Speicherung bestehen.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-9">Aktive Komponenten</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wir verwenden aktive Komponenten wie Javascript, Java-Applets oder Active-X-Controls.
          Dabei werden bestimmte technische Informationen, wie z.B. Browsertyp oder -version, lokal
          im Browser ausgewertet. Eine Übermittlung dieser Informationen an unsere Server oder an
          Dritte findet nicht statt. Diese Funktionen können durch die Einstellung Ihres
          Internetbrowsers von Ihnen abgeschaltet werden. JavaScript ist technisch erforderlich für
          den vollen Funktionsumfang unserer Anwendung.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-9">Änderungen dieser Datenschutzerklärung</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Wir passen unsere Datenschutzerklärung regelmäßig auf unsere Geschäftsabläufe und die
          geltende Rechtslage an.
        </p>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  metaInfo() {
    const title = "Datenschutzerklärung - open bydata";
    return {
      titleTemplate(chunk) {
        return title;
      },
    };
  },
}
</script>
